<template>
  <v-dialog
    v-model="this.isDialogOpen"
    scrollable
    content-class="ma-2"
    :max-width="540"
    :persistent="true"
  >
    <v-card class="pa-0">
      <div style="margin: 35px 37px 23.8px">
        <h2
          class="dialog-title text-bold"
          style="line-height: normal; font-size: 28px"
        >
          Session expired
        </h2>
      </div>

      <v-divider></v-divider>

      <v-card-text style="padding: 20.8px 0 40px 0">
        <div>
          <div class="dialog-content">
            <div>
              <p>Sorry! Your session has expired.</p>
            </div>
            <div>
              <p>You are now being re-directed to the home page.</p>
            </div>
            <div>
              <p>
                If you haven't been re-directed automatically in 30 seconds,
                please click the button below.
              </p>
            </div>
          </div>
          <div
            class="px-4"
            style="display: flex; justify-content: center; margin-top: 36px"
          >
            <BaseButton
              text="CONTINUE"
              rounded
              :block="$vuetify.breakpoint.lgAndUp ? false : true"
              class="font-weight-bold dialog-button"
              height="60"
              :min-width="$vuetify.breakpoint.lgAndUp ? '420' : ''"
              :color="'#fab519'"
              :fontSize="'font-20'"
              @click="redirect"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { getLandingPageLink } from "@/common/navigating";
import { ROUTE_URL } from "@/constants/route.constants";
export default {
  name: "SessionExpiredDialog",
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
  },
  computed: {
    isLandLordJourney() {
      return this.$route.path.includes(ROUTE_URL.LANDLORD_D2C);
    },
  },
  methods: {
    redirect() {
      window.location.href = getLandingPageLink();
    },
  },
};
</script>
<style scoped lang="scss">
:deep(.v-dialog) {
  border-radius: 20px !important;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #fff;
}
.dialog-title {
  color: #272727;
}
.dialog-content {
  height: 160px;
  font-size: 16px;
  margin: 0 40px 0 37px;
  letter-spacing: 0.4px;
  color: #272727;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;

  p {
    margin-bottom: 0;
  }
}
.dialog-button {
  color: #272727;
}

.block-header {
  font-weight: bold;
}
</style>
